import React from 'react'
import { useInView } from 'react-intersection-observer'

import { AuctionTableRow, AuctionTableRowProps } from './TableRow'

export const AuctionTableRowInView: React.FC<AuctionTableRowProps> = (props) => {
  const { quadkey } = props

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  return inView ? <AuctionTableRow quadkey={quadkey} /> : <div style={{ height: '10px' }} ref={ref} />
}
